module.exports = __webpack_public_path__ + "img/whatsapp.f4ad7c4d.svg";